import React, { useState, useEffect } from "react";
import { NumericFormat } from 'react-number-format';
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from 'react-paginate';

function AdsList() {
  const [ads, setAds] = useState([]);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keywordtitle, setKeywordTitle] = useState("");
  const [querytitle, setQueryTitle] = useState("");
  const [keywordstatus, setKeywordStatus] = useState("");
  const [querystatus, setQueryStatus] = useState("");
  const [msg, setMsg] = useState("");
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    getAds();
  }, [page, keywordtitle, keywordstatus]);

  const getAds = async () => {
    const response = await axios.get(
      `${API_BASE_URL}/ads?search_title=${keywordtitle}&search_status=${keywordstatus}&page=${page}&limit=${limit}`,
      {
        headers: {
            'X-API-Key': API_KEY
        },
      }
    );
    setAds(response.data.result);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
      setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordTitle(querytitle);
    setKeywordStatus(querystatus);
  };

  const deleteAds = async (adsId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await axios.delete(`${API_BASE_URL}/ads/${adsId}`);
      getAds();
    } else {
      return
    }  
  };

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Data Advertisement</h1>         
            <Link to="/ads/add" className="button is-small is-primary mb-2">
              Add New 
            </Link>           
            <div className="columns">
            <div className="column is-6">
              <form onSubmit={searchData}>
                <div className="field has-addons">
                  <div className="control is-expanded">
                    <input
                      type="text"
                      className="input is-small"
                      value={querytitle}
                      onChange={(e) => setQueryTitle(e.target.value)}
                      placeholder="Search by title..." />
                  </div>
                  <div className="control is-expanded">
                    <input
                      type="text"
                      className="input is-small"
                      value={querystatus}
                      onChange={(e) => setQueryStatus(e.target.value)}
                      placeholder="Search by broadcast status..." />
                  </div>
                  <div className="control">
                    <button type="submit" className="button is-small is-info">
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="table-container">
        <table className="table is-striped is-fullwidth is-size-7">
          <thead>
            <tr>
              <th className="th-cell-width-5">No</th>
              <th className="has-text-centered th-cell-width-10">Actions</th>  
              <th className="has-text-centered">Image</th>
              <th className="has-text-centered">Title</th>
              <th className="has-text-centered">Subtitle</th>
              <th className="has-text-centered">Broadcast_Status</th>
              <th className="has-text-centered">Last_Update</th>      
            </tr>
          </thead>
          <tbody>
            {ads.map((item, index) => (
              <tr key={item.uuid}>
                <td>{index + 1}</td>
                <td className="has-text-centered">
                  <div className="is-inline-flex">
                    <Link
                      to={`/ads/edit/${item.uuid}`}
                      className="button is-small is-info mr-1"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => deleteAds(item.uuid)}
                      className="button is-small is-danger"
                    >
                      Delete
                    </button>
                  </div>
                </td>
                <td className="has-text-centered">
                  <figure className="image has-text-centered is-48x48">
                    <img src={item.url} alt="Image" />
                  </figure>
                </td>
                <td>{item.title}</td>
                <td>{item.subtitle}</td>
                <td className="has-text-centered">
                      {(item.broadcast_status==="ON") ? <span className="tag is-success">{item.broadcast_status}</span>
                      : <span className="tag is-danger">{item.broadcast_status}</span> }
                  </td>
                <td className="has-text-centered">
                  {new Date(item.updatedAt).toLocaleDateString('id', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false,
                  })}                    
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="is-size-7">
          Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
        </p>
        <p className="has-text-centered has-text-danger">{msg}</p>
        <nav
          className="pagination is-centered is-size-7"
          key={rows}
          role="navigation"
          aria-label="pagination"
        >
          <ReactPaginate
            breakLabel="..."
            previousLabel={"< Prev"}
            nextLabel={"Next >"}
            pageCount={Math.min(10, pages)}
            onPageChange={changePage}
            containerClassName={"pagination-list"}
            pageLinkClassName={"pagination-link"}
            previousLinkClassName={"pagination-previous"}
            nextLinkClassName={"pagination-next"}
            activeLinkClassName={"pagination-link is-current"}
            disabledLinkClassName={"pagination-link is-disabled"} />
        </nav>
      </div>
    </div>
  );
}

export default AdsList;
